import { render, staticRenderFns } from "./SetupBulkUpload.vue?vue&type=template&id=2f85a10d&scoped=true"
import script from "./SetupBulkUpload.vue?vue&type=script&lang=js"
export * from "./SetupBulkUpload.vue?vue&type=script&lang=js"
import style0 from "./SetupBulkUpload.vue?vue&type=style&index=0&id=2f85a10d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f85a10d",
  null
  
)

export default component.exports